var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinLtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "url(#paint0_linear_1636_7998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8113 27.9841V28.0807L31.0707 30.7142C31.0266 30.845 30.9414 30.9579 30.8279 31.0363C30.7143 31.1146 30.5784 31.1541 30.4405 31.1489L15.2605 31.878L17.4662 24.2236L14.6533 25.0976L15.2237 23.3519L18.032 22.4664L21.137 11.73C21.1809 11.5967 21.2656 11.4806 21.3791 11.398C21.4926 11.3155 21.6292 11.2707 21.7695 11.27L25.5645 11.0998C25.6898 11.0824 25.817 11.1145 25.9192 11.1892C26.0213 11.2638 26.0904 11.3753 26.1119 11.5V11.6472L23.5267 20.7184L26.3419 19.8329L25.8198 21.6729L22.9563 22.5147L21.3463 28.0807L31.257 27.6437C31.3754 27.619 31.4987 27.6405 31.6018 27.7037C31.7048 27.767 31.7798 27.8673 31.8113 27.9841Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1636_7998",
    x1: 23,
    y1: 46,
    x2: 23,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C3678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C73FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLtc);
export default __webpack_public_path__ + "static/media/coin_ltc.ec7215de9cc36a7bbd96cbf0cd0aee61.svg";
export { ForwardRef as ReactComponent };